import React, { FC } from 'react';
import { fc } from 'i18n';

import { Controls } from './controls';
import { TableFooter } from './footer';
import { ErrorModal } from './modals/error-modal';
import { DevicesModal } from './modals/devices-modal';
import { StickyTable } from 'components/organisms/sticky-table';
import { useTepDevicesTable } from 'hooks/tep/devices/useTepDevicesTable';

import styles from './styles.module.css';

export const TepDevicesManagement: FC = () => {
  const { isDevicesModal, controlProps, tableProps, footerProps, closeModal, addEntryPasses } = useTepDevicesTable();

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.header}>{fc('TEP devices management')}</div>
        <Controls {...controlProps} />
        <StickyTable {...tableProps} />
        {!!tableProps.data?.length && <TableFooter {...footerProps} />}
      </div>
      {isDevicesModal && <DevicesModal closeModal={closeModal} onSubmit={addEntryPasses} />}
      <ErrorModal />
    </div>
  );
};
